define(function(require) {
	const Marionette = require('backbone.marionette');
	const $ = require('jquery');
	const Radio = require('backbone.radio');
	const ViewManager = require('civicsUtils/view_manager');
	const PasswordResetLayoutView = require('./v_lov_login_passwordReset');
	const QuestionLayoutView = require('./v_lov_login_question');
	const SigninLayoutView = require('./v_lov_login_signin');
	const activationFailedView = require('./v_itv_activation_failed');
	const InvitationUtils = require('civicsUtils/invitation_utilities');
	const LoginStatusModel = require('civicsModels/login_status_model');
	const ModalRegion = require('civicsUtils/modal_region');
	const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');
	const MFAEnforcedSetupModal = require('civicsViews/core/two_factor_authentication/enforced_setup/views/v_lov_enforced_setup.js');
	const AvailableFeatures = require('civicsUtils/available_features');
	const processManager = require('civicsUtils/process_manager/process_manager');

	var IpsModel = require('civicsBase/ipsModel');
  	const user_utils = require('civicsUtils/user_utils');

	const tpl = require('./templates/t_lov_login.hbs');

	return Marionette.LayoutView.extend({
		regions: {
			// PasswordResetLayoutViewRegion: '.password-reset-region',
			// QuestionLayoutViewRegion: '.questionLayoutView',
			SigninLayoutViewRegion: '.signin-region',
			// activationFailedRegion:'@ui.activationFailedDiv',
			modalRegion:{
				regionClass: ModalRegion,
				selector:'body .rhythm-modals'
			},
		},
		ui:{
			activationFailedDiv:'.activation-failed-region',
			loginRegionDivs:'.login-region'
		},
		childEvents:{
			'activationFailed2':'showActivationFailed',
			'mfa:setupRequired' : 'onMfaSetupRequired'
		},
		views:{},
		initializeReturnUrl:function() {
			if (this.config.return) {
				var ret = this.config.return.convertToReturnUrl();
				if(ret.substr(0,1) != '/'){
					ret = '/'+ret;
				}
				this.config.loginRedirectPage = ret;
				if (this.config.forgotPasswordPage) {
					//return looks like /start-project?{wizardtype:{0},session:{1}}
					this.config.forgotPasswordPage = this.config.forgotPasswordPage.concat(
							'/#return{0}'.format(ret));
				}
				if (this.config.registerUserPage) {
					this.config.registerUserPage = this.config.registerUserPage.concat(
							'/#return{0}'.format(ret));
				}
				if (this.config.forgotUsernameLink) {
					this.config.forgotUsernameLink = this.config.forgotUsernameLink.concat(
							'/#return{0}'.format(ret));
				}
			}

		},
		initialize: function(options) {
			var self = this;
			this.config = options.config;
			this.config.loginChannel = Radio.channel('LoginChannel' +  Math.floor(Math.random()*1000));			//make unique per portlet since there is 2 on the home page.
			this.isModal = options.isModal;
			this.isRedirect = options.isRedirect;
			this.initializeReturnUrl();
			this.config.globalConfig = ViewManager.globalConfig();
			//If this is the billing portal, then we dont use the security Q&A
			this.config.requireSecurityQuestion = this.config.isBillingPortal == true ? false : this.config.globalConfig.get('requireSecurityQuestion');
			
			// Store a reference to self so we can access modalRegion later even if context changes
			this.config.loginView = this;
			
			if (this.config.globalConfig.get('login')) {
				const lc = ViewManager.globalConfig().get('login').attributes;
				this.config = _.extend(this.config, {
					TitleOn: options.setTitle != undefined ? options.setTitle : lc.titleOn,
					Title: i18n.t('CIVICS.LOGIN.LOGIN_TITLE'),
					EmailUsernameOn: lc.emailUserNameOn,
					EmailUsernameLabel: i18n.t('CIVICS.LOGIN.EMAIL_ADDRESS'),
					RememberMeOn: lc.rememberMeOn,
					RememberMeLabel: i18n.t('CIVICS.LOGIN.REMEMBER_ME'),
					ForgotPasswordOn: lc.forgotPasswordOn,
					ForgotPasswordLabel: i18n.t('CIVICS.LOGIN.FORGOT_PASSWORD'),
					ForgotUsernameOn: lc.allowForgotUsername,
					ForgotUsernameLabel: i18n.t('CIVICS.LOGIN.FORGOT_USERNAME'),
					NewProfileOn: lc.newProfileOn,
					NewProfileTitle: i18n.t('CIVICS.LOGIN.CREATE_NEW_PROFILE'),
					NewProfileLabel: i18n.t('CIVICS.LOGIN.CREATE_NEW_PROFILE_MSG'),
					SigninError: lc.emailUserNameOn ? i18n.t('CIVICS.LOGIN.SIGN_IN_ERROR_EMAIL') : i18n.t('CIVICS.LOGIN.SIGN_IN_ERROR'),
					SigninLockedError: i18n.t('CIVICS.LOGIN.SIGN_IN_LOCKED_ERROR'),
					PasswordResetDifferentError: i18n.t('CIVICS.LOGIN.PASSWORD_RESET_DIFFERENT_ERROR'),
					PasswordResetError: i18n.t('CIVICS.LOGIN.PASSWORD_RESET_ERROR'),
					PasswordResetNochangeError: i18n.t('CIVICS.LOGIN.PASSWORD_RESET_NO_CHANGE_ERROR'),
					PasswordResetVerificationError: i18n.t('CIVICS.LOGIN.PASSWORD_RESET_VERIFICATION_ERROR'),
					PasswordExpired: i18n.t('CIVICS.LOGIN.PASSWORD_EXPIRED_ERROR'),
					QuestionError: i18n.t('CIVICS.LOGIN.QUESTION_ERROR'),
					hideRegisterLink:this.config.hideRegisterLink === true
				});
			}
			this.cancelCallback = options.cancelCallback;
			this.cancelCallbackOptions = options.cancelCallbackOptions;
			this.okCallback = options.okCallback;
			this.okCallbackOptions = options.okCallbackOptions;

			let timenow = Date.now();

			// create layout views
			this.signinLayoutView = new SigninLayoutView({
				config: this.config,
			});

			// setup radio channels
			this.config.loginChannel.comply('go:checkStatus', this.goCheckStatus.bind(this));
			this.config.loginChannel.comply('go:checkQuestion', this.goCheckQuestion.bind(this));
			this.config.loginChannel.comply('finalize:Authentication', this.finalizeAuthentication.bind(this));
			this.config.loginChannel.reply('original:settings', function() {
				return this.settings;
			}, this);

			// settings
			this.settings = {
				rememberMe: false,
				username: '',
			};
			if (typeof(Storage) !== 'undefined') {
				const storageSettings = localStorage.getItem('login.settings');
				if (storageSettings !== null) {
					const settings = JSON.parse(storageSettings);
					$.extend(this.settings, settings);
				}
			}
		},
		showActivationFailed:function() {
			this.views.activationFailedView = new activationFailedView({
				modalContainer:this.modalRegion
			});
			this.modalRegion.show(this.views.activationFailedView);
			this.modalRegion.showModal();
		},
		onShow: function() {
			// Store modalRegion reference in config for later access
			if (this.modalRegion) {
				this.config.modalRegionRef = this.modalRegion;
			}
			this.showSignin();
		},
		getModalRegion: function() {
			// Resolve modalRegion from multiple possible sources:
			// 1. Direct region (this.modalRegion)
			// 2. Cached reference (this.config.modalRegionRef - set in onShow)
			// 3. Self-reference (this.config.loginView.modalRegion)
			return this.modalRegion || this.config.modalRegionRef || (this.config.loginView && this.config.loginView.modalRegion);
		},
		goCheckQuestion: function() {
			if (this.goQuestion) {
				this.showQuestion();
			}
			else {
				// this.loginLiferay();
				this.finalizeAuthentication();
			}
		},
		goCheckStatus: function(loginView) {
			var statusModel = new LoginStatusModel();
			var self = this;
			ViewManager.loading(true);
			statusModel.fetch({
				success: _.bind(function(model, response) {
					ViewManager.loading(false);
					if (__DEV__) console.log('v_lov_login_sub.js - loginStatus success', model, response);
					this.goPasswordReset = model.get('isPasswordResetRequired');
					this.config.isPasswordExpired = model.get('isPasswordExpired');

					//Check Security Question and Answer.
					const passwordQuestion = model.get('passwordQuestion');
					const code = (passwordQuestion) ? passwordQuestion.get('code') : ' ';
					var hasSocialIdentity = response.socialIdentity !=null || model.get('socialIdentity') !=null;
					this.goQuestion = _.isEmpty(code.trim()) && this.config.requireSecurityQuestion ? true : (!code || /^\s*$/.test(code)) && this.config.requireSecurityQuestion;

					// Save this user
					App.user.id = response.data.contactId.id;
					if(hasSocialIdentity) {
						App.user.socialIdentity = model.get('socialIdentity');
					}

					// test force password reset
					// this.goPasswordReset = true;
					if (this.goPasswordReset) {
						this.showPasswordReset();
					}
					else if (this.goQuestion && !hasSocialIdentity) {
						this.showQuestion();
					}
					else {
						// this.loginLiferay();
						this.finalizeAuthentication();
					}
				}, this),
				error: _.bind(function(model, response) {
					ViewManager.loading(false);
					if (__DEV__) console.log('loginStatus error', model, response);
					if( response.responseText.indexOf('Read timed out') >= 0) {
						self.timeOutError(loginView);
					}
					this.config.loginChannel.command('go:authenticated');
				}, this),
			});
		},
		onMfaSetupRequired: function(config) {
			const modalRegion = this.getModalRegion();
			
			const enforcedMFASetupOnLogin = new MFAEnforcedSetupModal({
				config: config,
				modalRegion: modalRegion
			});
			modalRegion.show(enforcedMFASetupOnLogin);
			modalRegion.showModal();
		},
		timeOutError:function(loginView){
			var error = {};
			error.validationError = { password: i18n.t('CIVICS.LOGIN.TIMED_OUT_ERROR') };
			ViewManager.errorToWindow(error, loginView);
		},
		showPasswordReset: function() {
			const modalRegion = this.getModalRegion();
			this.passwordResetLayoutView = new PasswordResetLayoutView({
				loginLayoutView: this,
				config: this.config,
				modalContainer: modalRegion
			});
			
			// Check if modal region has been previously used (inst exists and not closed)
			// If so, use reshowModalView to properly close the current modal before showing the new one
			// Otherwise, show the modal directly with a delay to ensure any previous modal is fully closed
			if (modalRegion && modalRegion.inst && modalRegion.inst.state != 'closed') {
				this.reshowModalView(modalRegion, this.passwordResetLayoutView);
			} else if (modalRegion) {
				// Add a small delay to ensure previous modal is fully closed
				setTimeout(() => {
					modalRegion.show(this.passwordResetLayoutView);
					modalRegion.showModal();
					if (this.config) {
						this.config.reshowModal = null;
					}
				}, 100);
			} 
		},
		goToRecordDetails: function(){
			var invite = InvitationUtils.getStoredInvite();
			var targetPage = (invite && invite.intDetailTargetPage) || this.config.intDetailTargetPage;
			App.sessionStorage.remove('CIVICS', 'INVITE_RECORD');
			window.location.assign(targetPage);
		},
		showQuestion: function() {
			const modalRegion = this.getModalRegion();
			
			this.questionLayoutView = new QuestionLayoutView({
				loginLayoutView: this,
				config: this.config,
				modalContainer: modalRegion
			});
			if (modalRegion && modalRegion.inst && modalRegion.inst.state != 'closed') {
				this.reshowModalView(modalRegion, this.questionLayoutView);
			} else if (modalRegion) {
				modalRegion.show(this.questionLayoutView);
				modalRegion.showModal();
				this.config.reshowModal = null;
			}
		},
		reshowModalView: function(region, view) {
            if (this.config) {
                this.config.reshowModal = true;
            }

            region.closeModalPromise = $.Deferred();
            region.hideModal();

            // wait for the modal to fully close before reshowing a new modal
            $.when(region.closeModalPromise).done(() => {
                region.show(view);
                region.showModal();

            });
        },
		showSignin: function() {
			this.SigninLayoutViewRegion.show(this.signinLayoutView);

			if(this.isRedirect) {
				var error = {};
				error.validationError = {userloginform : i18n.t('PORTAL.LOGIN.SIGN_IN_REQUIRED') };
				ViewManager.errorToWindow(error, this.signinLayoutView);
			} else {
       			var errorMessage = App.sessionStorage.get('CIVICS', 'LOGOUT_MESSAGE');
                if( errorMessage && errorMessage != "" ){
                    ViewManager.openAlert( errorMessage );
                    App.sessionStorage.remove('CIVICS', 'LOGOUT_MESSAGE');
                }
            }
		},		
		
		finalizeAuthentication: function() {
			var signinSettings = this.config.loginChannel.request('signin:settings');
			if (typeof(Storage) !== 'undefined') {
				const settings = JSON.stringify(signinSettings, ['rememberMe', 'username']);
				if (signinSettings.rememberMe) {
					localStorage.setItem('login.settings', settings);
				}
				else {
					localStorage.removeItem('login.settings');
				}
			}

			$.when(user_utils.getPortalUser()).done(() => {
				if (typeof App.user.profiles !== 'undefined') {
					var defaultProfile;
					var hasDefault = false;

					if( !this.config.isBillingPortal) {
						App.user.profiles.forEach((profile) => {
							if (profile.default && profile.type === "organization") {
								defaultProfile = new IpsModel(profile);
								hasDefault = true;
							}
						});

						if (hasDefault && defaultProfile.get("id") !== App.user.id) {
							user_utils.switchProfile(defaultProfile, this.config.loginRedirectPage || null, true);
						}
					}

				}

				App.sessionStorage.remove('CIVICS','CIVICS_DATA');
				//Clear session storage values specific to the user so we can now load new values for this user.
				ViewManager.clearUserSpecificSessionStorage();
				ViewManager.clearUserSpecificLocalStorage();

				this.config.loginChannel.reset();
				// this.destroy();
				if (this.okCallback) {
					this.okCallback(this.okCallbackOptions);
				}

				this.globalConfig = ViewManager.globalConfig().toJSON();
				var loginRedirectConfig = this.globalConfig.loginRedirectPage;
			
				// INVITEE_UX OFF -> login auto-accepts invites here (legacy).
				// INVITEE_UX ON  -> invite portlet drives the flow; do not accept here.
				var usesInviteeNewUX = InvitationUtils.usesInviteeNewUX();

				var isInvitationActive = usesInviteeNewUX &&
					processManager.hasActiveProcess() &&
					processManager.getActiveProcess() === processManager.PROCESS_NAMES.INVITATION;

				if (!this.config.disableRedirectOnOk) {
					// Go to homepage or bookmarked URL
					if($(".redirect-input").first().val() != "") {
						window.location.assign($(".redirect-input").first().val());
					} else if (isInvitationActive) {
						processManager.setCurrentStep(processManager.INVITE_STEPS.POSTLOGIN);
						window.location.assign(processManager.getReturnURL());
					} else if( !usesInviteeNewUX && !this.config.isBillingPortal && (InvitationUtils.getStoredInvite() || InvitationUtils.getStoredAuthInvite())){ 
						this.handleInvites();
					} else if (AvailableFeatures.LoginRedirect()) {
						if (loginRedirectConfig && loginRedirectConfig.enabled) {
							//If current page is in the login redirect config
							//do not redirect to current page after login
							var pageIncludedInConfig = loginRedirectConfig.loginRedirectPages.find(function (e) {
								return window.location.href.indexOf(e.page) > 0
							});

							if (pageIncludedInConfig || window.location.pathname == '/') {
								window.location.assign(this.config.loginRedirectPage);
							} else {
								window.location.reload();
							}
						} else {
							window.location.assign(this.config.loginRedirectPage);
						}
					} else {
						window.location.assign(this.config.loginRedirectPage);
					}
				}

			});
			//console.log("App profile", App.user.profiles)

		},
		handleInvites: function() {
			//if the feature toggle for the improved invite UX is not enabled, the invites are handled here
			var invite = InvitationUtils.getStoredInvite();
			var authInvite = InvitationUtils.getStoredAuthInvite();

			if(authInvite != null){
				InvitationUtils.acceptAuthInvite(InvitationUtils.createAuthInvitePayload(authInvite))
					.then((response) => {
						this.acceptAuthInviteSuccess(response);
					}).fail((response) => {
						this.acceptAuthInviteError(response);
					});				
			} 
			
			else if(invite != null) {
				InvitationUtils.acceptAddtlApplicantInvite(InvitationUtils.createAddtlApplicantPayload(invite))
				.then((response) => {
					this.acceptInviteSuccess(response);
				}).fail((response) => {
					this.acceptInviteError(response);
				});
			}
		},
		acceptAuthInviteSuccess: function(model,response,options) {
			// success callback for auth invite
			App.sessionStorage.remove('CIVICS', 'AUTHORIZEDUSER_INVITE');
			App.sessionStorage.set('CIVICS', 'AUTHORIZEDUSER_WELCOME_INVITE', true);
			ViewManager.clearUserSpecificSessionStorage(['USER_SESSION'])
			window.location.assign(this.config.loginRedirectPage);
		},
		acceptAuthInviteError: function(model, response, options) {
			// error callback for auth invite
			ViewManager.openAlert(i18n.t('CIVICS.INVITE.ERROR_ACCEPTING_INVITE'));
		},
		acceptInviteSuccess: function(model,response,options) {
			//success callback for accept invite
			this.goToRecordDetails();
		},
		acceptInviteError: function(response) {
			//error callback for accept invite
			ViewManager.resetErrorMessages(this);
			if(response?.responseJSON?.responseStatus?.errorCode == "409"){
			var modal = new ConfirmationModal({
				title: i18n.t('CIVICS.COMMON.NOTIFICATION'),
				okLabel: i18n.t('CIVICS.COMMON.OK'),
				message: i18n.t('CIVICS.COMMON_INVITE_APPLICANT.ALREADY_ADDED'),
				modalRegion: this.modalRegion,
				showCancelButton: false,
				okCallback: () => {this.goToRecordDetails() },
				closeCallback: () => {this.goToRecordDetails()}
			});

			this.modalRegion.show(modal);
			this.modalRegion.showModal();

			} else {
				ViewManager.openAlert(i18n.t('CIVICS.INVITE.ERROR_ACCEPTING_INVITE'));
			}
		},
		template: tpl
	});
});
